"use client";

import Heading from "@/components/heading/heading";
import "./flights.scss"

const FlightsData = {
    to: {
        title: "Chennai To Colombo",
        information: [
            "Flight No : UL 122 [SriLankan Airlines]",
            "Departure Date : April 30 2025",
            "Departure Time : 09.55 AM (IST)",
            "Arrival Date : April 30 2025",
            "Arrival Time : 11.20 AM (IST)"
        ]
    },
    from: {
        title: "Colombo To Chennai",
        information: [
            "Flight No : UL 123 [SriLankan Airlines]",
            "Departure Date : May 04 2025",
            "Departure Time : 06.45 PM (IST)",
            "Arrival Date : May 04 2025",
            "Arrival Time : 08.10 PM (IST)"
        ]
    }
}


const Flights = () => {
    return (
        <div className="relative">
            <span id="flights" className="anchor anchor-flights"></span>
            <Heading as="h2" className="mt-3">Flights</Heading>
            <div className="md:flex relative" >
                <div className="mt-3">
                    <Heading as="h6">{FlightsData.to.title}</Heading>
                    <ul className="list mt-2 ml-2">
                        {FlightsData.to.information.map((item: any, index: any) => {
                            return (
                                <li className="list-item" key={index}>
                                    <span className="">
                                        {item}
                                    </span>
                                </li>
                            )
                        })}
                    </ul>
                </div>

                <div className="mt-3 md:ml-20">
                    <Heading as="h6">{FlightsData.from.title}</Heading>
                    <ul className="list mt-2 ml-2">
                        {FlightsData.from.information.map((item: any, index: any) => {
                            return (
                                <li className="list-item" key={index}>
                                    <span className="">
                                        {item}
                                    </span>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Flights